// removed by extract-text-webpack-plugin
module.exports = {"list":"g7_ce _2HU8ZgmfpIdsUwklJ4Ng6B _3JIEYde9anI6O5H5wYv2ik","label":"g7_g8"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventDetail/Labels/styles.module.css
// module id = 1297
// module chunks = 27